import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { isFeatureEnabled, type FlagName } from "@/services/feature-flags";

interface FeatureFlagRouteProps {
  flag: FlagName;
  fallbackPath: string;
  children: ReactNode;
}

export default function FeatureFlagRoute(
  { flag, fallbackPath, children }: FeatureFlagRouteProps,
) {
  if (!isFeatureEnabled(flag)) {
    return <Navigate to={fallbackPath} replace />;
  }

  return <>{children}</>;
}
